import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface OwnPortalProps {
    children: React.ReactNode;
    wrapperSelector?: string;
}

type PortalProps = OwnPortalProps &
    Omit<React.ComponentProps<'div'>, keyof OwnPortalProps>;

const Portal: React.FC<PortalProps> = ({ children, wrapperSelector = 'body', ...rest }) => {
    const [element] = useState(() => document.createElement('div'));

    useEffect(() => {
        Object.keys(rest).forEach(key => {
            const value = rest[key as keyof typeof rest];

            if (key === 'className' && typeof value === 'string') {
                element.className = value;
            } else if (key === 'style' && typeof value === 'object' && value !== null) {
                Object.assign(element.style, value);
            } else if (typeof value === 'string' || typeof value === 'number') {
                element.setAttribute(key, String(value));
            }
        });
        let portalRoot = document.querySelector(wrapperSelector);

        if (!portalRoot) {
            portalRoot = document.createElement('div');
            portalRoot.setAttribute('data-selector', wrapperSelector);
            document.body.appendChild(portalRoot);
        }

        portalRoot.appendChild(element);

        return () => {
            if (portalRoot && portalRoot.contains(element)) {
                portalRoot.removeChild(element);
            }
        };
    }, [wrapperSelector, element, rest]);

    return ReactDOM.createPortal(children, element);
};

export default Portal;
